export default __webpack_public_path__ + "static/media/G0006.d2c4b88b.png";